import _Object$keys from 'babel-runtime/core-js/object/keys';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import Ajv from 'ajv';
import GameDifficultySlider from './game-difficulty-slider.vue';
import GameDifficultySelect from './game-difficulty-select.vue';
import EditGameDifficultySliderPopover from './edit-game-difficulty-slider-popover.vue';
import ElCustomColorPicker from '@com/components/vue-colorpicker/index.vue';
import GameDifficultyLegend from './game-difficulty-legend.vue';
import { isHexColor } from '@com/utils/color';
import { language } from '@/common/storage';

export default {
  components: {
    GameDifficultySlider: GameDifficultySlider,
    GameDifficultySelect: GameDifficultySelect,
    EditGameDifficultySliderPopover: EditGameDifficultySliderPopover,
    ElCustomColorPicker: ElCustomColorPicker,
    GameDifficultyLegend: GameDifficultyLegend
  },

  props: {
    gameConfig: {
      type: Object,
      required: true
    },
    keyPath: {
      type: String,
      required: true
    },
    sliderEditable: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String,
      required: true
    },
    playConfig: {
      type: Object,
      required: false
    }
  },

  name: 'v3-game-difficulty-instance',

  data: function data() {
    return {
      inputFormValue: {
        input: ''
      },
      colorPickerFormValue: {
        color: ''
      },
      checkboxFormValue: {
        checkbox: []
      },
      inputNumberFormValue: {
        input: 0
      },
      isColorPicker: false
    };
  },


  computed: {
    gameConfigOptions: function gameConfigOptions() {
      var _this = this;

      if (_.isArray(this.gameConfig.options) && this.gameConfig.options.length > 0) {
        var options = _.cloneDeep(this.gameConfig.options);
        // 如果是对象，其格式是 [{value: 1, text: 'text'}]
        if (_.isPlainObject(options[0])) {
          return options.map(function (item) {
            return {
              value: item.value,
              text: _this.getTransLabel(item.text)
            };
          });
        }
        return options.map(function (item) {
          return {
            value: item,
            text: _this.getTransLabel(item)
          };
        });
      }
      return null;
    },
    gameConfigUnit: function gameConfigUnit() {
      var isLanguageEnglish = language.get() === 'en';
      var mappingPath = this.gameConfig.mw_mapping_path ? this.gameConfig.mw_mapping_path.replace('[gameConfig]', '') : '';
      var playConfig = this.playConfig && this.playConfig.gameConfig && mappingPath && _.get(this.playConfig.gameConfig, mappingPath);
      if (isLanguageEnglish) {
        return playConfig && playConfig.unit_en || this.gameConfig.unit;
      }
      return this.gameConfig.unit;
    },
    isInput: function isInput() {
      return this.gameConfig.type && this.gameConfig.type.indexOf('input') === 0;
    },
    isInputNumber: function isInputNumber() {
      return this.gameConfig.type && this.gameConfig.type.indexOf('input:number') === 0;
    },
    inputFormItem: function inputFormItem() {
      return {
        rules: [{
          required: true,
          message: this.$t('playTurbo.custom.difficultyV3.inputItem.required'),
          trigger: ['blur', 'change']
        }],
        prop: 'input',
        field: {
          clearable: true,
          maxlength: 50,
          type: 'textarea',
          autosize: true,
          placeholder: this.$t('playTurbo.custom.difficultyV3.inputItem.placeholder')
        }
      };
    },
    inputNumberFormItem: function inputNumberFormItem() {
      // 如果 gameConfig 在配置 inputNumber 时有对应的参数项，直接透传
      var inputNumberParams = _.pick(this.gameConfig, ['min', 'max', 'step', 'step-strictly', 'precision', 'controls', 'controls-position']);
      return {
        rules: [{
          required: true,
          message: this.$t('playTurbo.custom.difficultyV3.inputNumberItem.required'),
          trigger: ['blur', 'change']
        }],
        prop: 'input',
        field: _extends({}, inputNumberParams, {
          placeholder: this.$t('playTurbo.custom.difficultyV3.inputNumberItem.placeholder')
        })
      };
    },
    colorPickerFormItem: function colorPickerFormItem() {
      return {
        rules: [{
          validator: this.colorValidator,
          trigger: ['blur', 'change']
        }],
        prop: 'color',
        field: {
          class: 'game-config-color-picker'
        }
      };
    },
    checkboxFormItem: function checkboxFormItem() {
      var isCheckbox = this.gameConfig.type === 'checkbox';
      var field = {};
      if (isCheckbox) {
        field.min = this.gameConfig.minItems >= 0 ? this.gameConfig.minItems : 1; // 如果没有定制值，默认至少要选一个
        this.gameConfig.maxItems >= 0 && (field.max = this.gameConfig.maxItems);
      }
      var rules = [];
      if (field.min > 0) {
        rules.push({
          required: true,
          message: this.$t('playTurbo.custom.difficultyV3.checkboxItem.required'),
          trigger: 'change'
        });
      }
      return {
        rules: rules,
        prop: 'checkbox',
        field: field
      };
    },


    // value 为数组，但是没有 items，且 subtype 是 slider 或 input
    isArrayWithoutItems: function isArrayWithoutItems() {
      return Array.isArray(this.gameConfig.value) && !this.gameConfig.items && (this.gameConfig.subtype === 'slider' || this.gameConfig.subtype === 'input');
    },
    nestInstance: function nestInstance() {
      var _this2 = this;

      if (this.gameConfig.type !== 'array' && this.gameConfig.type !== 'object' && this.gameConfig.type !== 'arrayObject') {
        return null;
      }

      // 自定义数组子项
      if (this.gameConfig.type === 'array' && Array.isArray(this.gameConfig.items)) {
        return this.gameConfig.items;
      }

      // 自定义对象子项
      if (this.gameConfig.type === 'object' && _.isPlainObject(this.gameConfig.items)) {
        return this.gameConfig.items;
      }

      // arrayObject 类型处理
      if (this.gameConfig.type === 'arrayObject' && Array.isArray(this.gameConfig.items)) {
        return this.gameConfig.items;
      }

      // value 为数组，但是没有 items，且 subtype 是 slider 或 input，这种数据不需要渲染子项的标题与描述
      if (Array.isArray(this.gameConfig.value)) {
        return this.gameConfig.value.map(function (item, index) {
          // 嵌套 slider
          if (_this2.gameConfig.subtype === 'slider') {
            return {
              value: item,
              min: _this2.gameConfig.min,
              max: _this2.gameConfig.max,
              type: 'slider',
              unit: _this2.gameConfig.unit,
              mw_slider_editable: false
            };
          }

          // 嵌套 input
          if (_this2.gameConfig.subtype && _this2.gameConfig.subtype.indexOf('input') === 0) {
            return {
              value: item,
              type: 'input'
            };
          }

          return null;
        });
      }

      return null;
    },
    schema: function schema() {
      var schema = this.$store.state.creative.schema;
      if (_.isArray(this.gameConfig.type)) {
        return schema.array[this.gameConfig.subtype];
      }
      return schema[this.gameConfig.type];
    },
    errors: function errors() {
      var schema = this.schema;

      if (schema) {
        var ajv = new Ajv({ allErrors: true });
        var validate = ajv.compile(schema);
        var valid = validate(this.gameConfig);

        if (!valid) {
          return validate.errors;
        }
      }

      return [];
    },
    isLegal: function isLegal() {
      return this.errors.length === 0;
    },


    // 为 arrayObject 类型生成标题和描述的配置
    arrayObjectLegendConfigs: function arrayObjectLegendConfigs() {
      if (this.gameConfig.type !== 'arrayObject' || !Array.isArray(this.gameConfig.items)) {
        return [];
      }

      return this.gameConfig.items.map(function (item) {
        return {
          title: item.title || item.desc || '配置项',
          desc: item.desc || item.title || '配置描述'
        };
      });
    }
  },

  watch: {
    gameConfig: function gameConfig() {
      if (this.gameConfig.type === 'checkbox') {
        this.initCheckbox(false);
      }

      if (this.isInput) {
        if (isHexColor(this.gameConfig.value)) {
          this.initColorPicker(false);
        } else {
          this.initInput(false);
        }
      }

      if (this.gameConfig.type === 'color-picker') {
        this.initColorPicker(false);
      }
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    if (!this.isLegal) {
      this.$emit('add-validator', function () {
        return _Promise.reject(new Error(_this3.keyPath + ' ' + _this3.$t('playTurbo.custom.difficultyV3.alertText')));
      });
    } else {
      if (this.gameConfig.type === 'checkbox') {
        this.initCheckbox();
      }

      if (this.isInputNumber) {
        this.initInputNumber();
      } else if (this.isInput) {
        if (isHexColor(this.gameConfig.value)) {
          this.initColorPicker();
        } else {
          this.initInput();
        }
      }

      if (this.gameConfig.type === 'color-picker') {
        this.initColorPicker();
      }
    }
  },


  methods: {
    initColorPicker: function initColorPicker() {
      var _this4 = this;

      var isAddValidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.isColorPicker = true;
      this.colorPickerFormValue.color = this.gameConfig.value;
      isAddValidate && this.$nextTick(function () {
        return _this4.$emit('add-validator', _this4.$refs['color-picker-form'].validate);
      });
    },
    initInputNumber: function initInputNumber() {
      var isAddValidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.inputNumberFormValue.input = this.gameConfig.value;
      isAddValidate && this.$emit('add-validator', this.$refs['input-number-form'].validate);
    },
    initInput: function initInput() {
      var isAddValidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.inputFormValue.input = this.gameConfig.value;
      isAddValidate && this.$emit('add-validator', this.$refs['input-form'].validate);
    },
    initCheckbox: function initCheckbox() {
      var isAddValidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.checkboxFormValue.checkbox = this.gameConfig.value;
      isAddValidate && this.$emit('add-validator', this.$refs['checkbox-form'].validate);
    },
    colorValidator: function colorValidator(rule, value, callback) {
      if (this.gameConfig.value === '' && value === '') {
        callback(new Error('Please choose a color'));
      } else if (!isHexColor(value)) {
        callback(new Error('Color format error'));
      } else {
        callback();
      }
    },
    handleInput: function handleInput(value) {
      // 清理输入内容的换行符
      var formatValue = value.trim();
      // eslint-disable-next-line vue/no-mutating-props
      this.gameConfig.value = formatValue;
      this.$emit('change', {
        conf: _extends({}, this.gameConfig, { formatValue: formatValue }),
        key: this.keyPath
      });
    },
    handleInputNumber: function handleInputNumber(value) {
      this.inputNumberFormValue.input = value;
      this.$emit('change', {
        conf: _extends({}, this.gameConfig, { value: value }),
        key: this.keyPath
      });
    },
    handleColorPick: function handleColorPick(val) {
      var _this5 = this;

      var value = '';
      if (val === null) {
        value = '';
      } else {
        value = val;
      }
      this.colorPickerFormValue.color = value;
      this.$emit('change', {
        conf: _extends({}, this.gameConfig, { value: value }),
        key: this.keyPath
      });
      // fix el-color bug：change时去校验一次 color-picker 组件，保证其校验结果是正确的
      this.$nextTick(function () {
        return _this5.$refs['color-picker-form'] && _this5.$refs['color-picker-form'].validate();
      });
    },
    handleRadioChange: function handleRadioChange(value) {
      this.$emit('change', {
        conf: _extends({}, this.gameConfig, { value: value }),
        key: this.keyPath
      });
    },
    handleCheckboxChange: function handleCheckboxChange(value) {
      this.$emit('change', {
        conf: _extends({}, this.gameConfig, { value: value }),
        key: this.keyPath
      });
    },
    handleNestInstanceChange: function handleNestInstanceChange(_ref) {
      var conf = _ref.conf,
          key = _ref.key,
          index = _ref.index;

      // 如果有 items，代表是数组或对象
      // 其子项的组件是自定义格式，如是 slider 与 color-picker 组合
      if (Array.isArray(this.gameConfig.items) || _.isPlainObject(this.gameConfig.items)) {
        this.$emit('change', {
          conf: conf,
          key: key
        });
      }

      // 如果有 value，代表数组的子项的组件使用相同的组件，如都是 slider
      if (Array.isArray(this.gameConfig.value)) {
        var value = this.gameConfig.value;
        value[index] = conf.value;
        this.$emit('change', {
          conf: _extends({}, this.gameConfig, { value: value }),
          key: this.keyPath
        });
      }
    },
    handleArrayObjectChange: function handleArrayObjectChange(_ref2) {
      var conf = _ref2.conf,
          key = _ref2.key,
          index = _ref2.index,
          fieldKey = _ref2.fieldKey;

      // 更新 arrayObject 中特定字段的配置
      if (Array.isArray(this.gameConfig.items)) {
        var items = [].concat(_toConsumableArray(this.gameConfig.items));
        if (items[index] && items[index].items && items[index].items[fieldKey]) {
          // 更新子项的配置，同时保持 value 和 items 的同步
          var updatedFieldConfig = _extends({}, items[index].items[fieldKey], conf, {
            // 如果子项有 value 字段，也要同步更新
            value: conf.value !== undefined ? conf.value : items[index].items[fieldKey].value,
            // 如果子项有 items 字段，也要同步更新
            items: conf.items !== undefined ? conf.items : items[index].items[fieldKey].items
          });

          items[index] = _extends({}, items[index], {
            items: _extends({}, items[index].items, _defineProperty({}, fieldKey, updatedFieldConfig)),
            // 同时更新 value 字段以保持一致性
            value: _extends({}, items[index].value, _defineProperty({}, fieldKey, updatedFieldConfig))
          });
          this.$emit('change', {
            conf: _extends({}, this.gameConfig, { items: items }),
            key: this.keyPath
          });
        }
      }
    },
    handleNormalArraySliderPopoverChange: function handleNormalArraySliderPopoverChange(_ref3) {
      var min = _ref3.min,
          max = _ref3.max;

      this.$emit('change', {
        conf: _extends({}, this.gameConfig, { min: min, max: max }),
        key: this.keyPath
      });
    },
    getCardProps: function getCardProps() {
      return {
        shadow: 'never',
        style: 'margin-bottom: 5px;',
        bodyStyle: 'padding: 5px 0;'
      };
    },
    getArrayType: function getArrayType() {
      // 普通数组配置
      // { type: 'array', value: [1,2,3], subtype: 'input' }
      if (this.gameConfig.type === 'array' && _.isArray(this.gameConfig.value) && _.isUndefined(this.gameConfig.items)) {
        return 'normal-array';
      }
      // 自定义数组配置
      // { type: 'array', items: [{}, {}] }
      if (this.gameConfig.type === 'array' && _.isArray(this.gameConfig.items)) {
        return 'custom-items-array';
      }
      return '';
    },
    getTransLabel: function getTransLabel(label) {
      var isLanguageEnglish = language.get() === 'en';
      var gameConfigOptionsEn = this.gameConfig.options_en;
      var mappingPath = this.gameConfig.mw_mapping_path ? this.gameConfig.mw_mapping_path.replace('[gameConfig]', '') : '';
      var playConfigOptionsEn = this.playConfig && this.playConfig.gameConfig && mappingPath && _.get(this.playConfig.gameConfig, mappingPath) && _.get(this.playConfig.gameConfig, mappingPath).options_en;
      /**
       * 兼容 gameConfig 里面含有 options_en 的场景
       * 为什么部分要存在 playConfig 里面，部分要存在 gameConfig 里面？
       * 因为素材里面的 gameConfig 是基础包内容，如果直接更新 gameConfig 字段会直接影响素材包体，所以设计的时候就把平台中消费但素材不消费的字段都放到 playConfig 里面
       * 然而有些配置并不是基础包内容，如 presetConfig ，这个是平台生成并且是平台消费的，这时候就不需要额外放在 playConfig 里面了
       */
      if (isLanguageEnglish && (gameConfigOptionsEn || playConfigOptionsEn)) {
        var options_en = gameConfigOptionsEn || playConfigOptionsEn;
        // 如果是对象，需要获取对应的 label
        if (this.gameConfig.options.length > 0 && _.isPlainObject(this.gameConfig.options[0])) {
          var _optionIndex = this.gameConfig.options.findIndex(function (item) {
            return item.text === label || item.label === label;
          });
          return options_en[_optionIndex].text;
        }
        var optionIndex = this.gameConfig.options.findIndex(function (item) {
          return String(item) === String(label);
        });
        return options_en[optionIndex];
      }
      return label;
    },
    handleDeleteArrayObjectItem: function handleDeleteArrayObjectItem(index) {
      // 删除 arrayObject 中的指定项
      if (Array.isArray(this.gameConfig.items) && index > 0) {
        var items = [].concat(_toConsumableArray(this.gameConfig.items));
        items.splice(index, 1);
        this.$emit('change', {
          conf: _extends({}, this.gameConfig, { items: items }),
          key: this.keyPath
        });
      }
    },
    handleAddArrayObjectItem: function handleAddArrayObjectItem() {
      var _this6 = this;

      // 新增 arrayObject 项目：拷贝第一个元素
      if (Array.isArray(this.gameConfig.items) && this.gameConfig.items.length > 0) {
        var items = [].concat(_toConsumableArray(this.gameConfig.items));
        var firstItem = _.cloneDeep(items[0]);
        var newIndex = items.length;

        // 为新项目生成新的字段名（避免重复）
        var newItem = {
          desc: firstItem.desc + '-' + (newIndex + 1),
          type: 'object', // 添加 type 字段，确保保存时能正确处理
          value: {},
          items: {}
        };

        _Object$keys(firstItem.items).forEach(function (key) {
          // 直接复用原始字段名，不添加序号
          var fieldConfig = _extends({}, firstItem.items[key], {
            // 重新生成 mw_mapping_path，只替换下标
            mw_mapping_path: _this6.generateNewMappingPath(newIndex, key, firstItem.items[key].mw_mapping_path)

            // 确保新创建的子项也有 items 字段（如果原来有 value 的话）
          });if (fieldConfig.value && !fieldConfig.items) {
            fieldConfig.items = fieldConfig.value;
          }

          newItem.items[key] = fieldConfig;
          newItem.value[key] = fieldConfig;
        });

        items.push(newItem);
        this.$emit('change', {
          conf: _extends({}, this.gameConfig, { items: items }),
          key: this.keyPath
        });
      }
    },
    generateNewMappingPath: function generateNewMappingPath(itemIndex, fieldKey, originalMappingPath) {
      // 基于原始 mw_mapping_path 替换下标和字段名
      // 例如：原始路径 "[gameConfig][test.arrayObject][items][0][items][slider1]"
      // 新路径："[gameConfig][test.arrayObject][items][1][items][slider2]"
      if (!originalMappingPath) {
        return '';
      }

      // 替换 items 后的索引
      var newPath = originalMappingPath.replace(/\[items\]\[\d+\]/, '[items][' + itemIndex + ']');

      // 替换最后的字段名
      return newPath.replace(/\[\w+\]$/, '[' + fieldKey + ']');
    }
  }
};